<div class="p-3">
  <div class="page-title d-flex justify-content-between align-items-center px-1">
    <h3>Message Templates</h3>
    <div class="d-flex gap-2" *ngIf="templateName != 'Both'">
      <p-button type="button" label="Add Template" icon="pi pi-plus" class="primary-btn" (click)="showDialogForCreate('right')"></p-button>
    </div>
  </div>

  <div class="templates-listing p-3 m-1 mt-3">
    <h4>To {{templateName}}</h4>
    <p-table *ngIf="templateName != 'Both'"
      [value]="templates" 
      [lazy]="true" 
      responsiveLayout="scroll"
      [paginator]="true" 
      [rows]="itemsPerPage" 
      [totalRecords]="totalRecords"
      (onLazyLoad)="loadTemplates(templatesOf,$event)"
      [sortField]="sorting.field" 
      [sortOrder]="sorting.order"
      [rowsPerPageOptions]="[10,20,50]"  
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
  
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="sortId">Message Order <p-sortIcon field="sortId"></p-sortIcon></th>
          <th pSortableColumn="content">Title <p-sortIcon field="content"></p-sortIcon></th>
          <th pSortableColumn="content">Subject <p-sortIcon field="content"></p-sortIcon></th>
          <th>Event Type</th>
          <th>Event Trigger</th>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="body" let-template>
        <tr>
          <td>{{ template.sortId }}</td>
          <td>{{ template.title }}</td>
          <td>{{ template.subject }}</td>
          <td>{{ template.eventType }}</td>
          <td>{{ generateSendTimeMessage({entity: 'When Lead', eventType: template.eventType, sendTimeCondition: template.sendTimeCondition, sendTime: template.sendTime}) }}</td>
          <td>
            <div class="d-flex align-items-center gap-2">
            <p-button
              pButton
              icon="pi pi-pencil"
              class="icon-secondary-btn"
              (click)="showDialogForEdit('right', template)"
            ></p-button>
            <p-button type="button" icon="pi pi-trash" class="icon-primary-btn" (click)="confirmDeleteTemplate(template)"
            *ngIf="template.eventType !== 'autoCancel'"></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div *ngIf="(!templates || templates.length === 0) && templateName != 'Both'" class="alert alert-danger text-center" role="alert">
    No {{templateName}} templates available.
  </div>

  <div *ngIf="templateName == 'Both'" class="alert alert-danger text-center" role="alert">
    Coming Soon!.
  </div>
</div>

<p-dialog
  *ngIf="visible"
  [header]="selectedTemplate ? 'Update Template' : 'Create Template'"
  [modal]="true"
  [(visible)]="visible"
  [position]="position"
  [style]="{ width: '35%' }"
  draggable="false">
  <app-create-template
    *ngIf="visible"
    [buttonLabel]= "selectedTemplate ? 'Update' : 'Create'"
    [sendTo]="templatesOf"
    [templateData]="selectedTemplate"
    (closeDialog)="onDialogClose()"
  ></app-create-template>
</p-dialog>

<!-- Confirm Cancel Dialog -->
<p-dialog header="Confirm Cancel" [(visible)]="showCancelDialog" modal="true" [closable]="false" [responsive]="true" [style]="{width: '350px'}">
  <div class="confirmation-content">
    <p>Are you sure you want to cancel? All unsaved changes will be lost.</p>
  </div>
  <div class="d-flex justify-content-end gap-2 mt-3">
    <p-button label="No" (click)="declineCancel()"></p-button>
    <p-button label="Yes" class="p-button-danger" (click)="confirmCancelAdd()"></p-button>
  </div>
</p-dialog>

<!-- Confirm Delete Dialog -->
<p-dialog header="Confirm Delete" [(visible)]="showDeleteDialog" modal="true" [closable]="false" [responsive]="true" [style]="{width: '350px'}">
  <div class="confirmation-content">
    <p>Are you sure you want to delete this template?</p>
  </div>
  <div class="d-flex justify-content-end gap-2 mt-3">
    <p-button label="No" (click)="cancelDelete()"></p-button>
    <p-button label="Yes" class="p-button-danger" (click)="deleteTemplate()"></p-button>
  </div>
</p-dialog>
